export const yapayData = ({ yapayData }) => yapayData
export const passwordYapay = ({ passwordYapay }) => passwordYapay
export const emailYapay = ({ emailYapay }) => emailYapay
export const splits = ({ splits }) => splits




// WEBPACK FOOTER //
// ./src/app/pages/payments/vuex/getters.js